let initialFields = {
  assessment: "Normal",
  assessmentAbnormal: "",
};

export default initialFields;
